// @ts-check
import ExaplainerModal from './ExplainerModal';

export default ExaplainerModal;
